import { appCalendarIcon } from './calendar';
import { appClockPlusIcon } from './clock-plus';
import { appClockRewindIcon } from './clock-rewind';
import { appClockIcon } from './clock';
export const timeIcons = [appCalendarIcon, appClockPlusIcon, appClockRewindIcon, appClockIcon];
